// extracted by css-extract-rspack-plugin
export default {"root":"uZ5vn"};